import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { colorBlend, colorOpacity, colorShade } from '../../utils/style';

interface ProgressLiquidProps {
    value?: number | 'indeterminate';
    width?: number | `${number}%`
    height?: number | `${number}%`
    className?: string;
}

export default function ProgressLiquid({ value = 0, width, height, className }: ProgressLiquidProps) {
    const selfRef = useRef<HTMLDivElement>(null)
    const progressRef = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        const progressRect = (progressRef.current as HTMLDivElement).getBoundingClientRect();
        // if (value !== 'indeterminate') (progressRef.current as HTMLDivElement).style.transform = `translateY(${-15 + 85 - value * 0.70}%)`;
        if (value !== 'indeterminate') (progressRef.current as HTMLDivElement).style.transform = `translateY(${100 - value}%)`;
    }, [value])
    return (
        <Wrapper className={className} ref={selfRef} style={{ width, height }}>
            <div className='progress-liquid' ref={progressRef}>
                <div className='progress-liquid-wave'>
                    <svg viewBox="0 0 560 20" className='progress-liquid-wave-svg' overflow='visible'>
                        <symbol id="thescorewave" overflow='visible'>
                            <path d="m-0.01 0v20h140.01c-21.5-0.4-38.8-2.5-51.1-4.5-13.4-2.2-26.501-5.2004-27.301-5.4004-15.6-3.6-19.6-5.4004-30.1-7.4004-7.2-1.3-17.91-2.7992-31.51-2.6992zm140.01 20h280c-21.5-0.4-38.8-2.5-51.1-4.5-13.4-2.2-26.501-5.2004-27.301-5.4004-15.6-3.6-19.6-5.4004-30.1-7.4004-7.2-1.3-17.9-2.7992-31.5-2.6992-13.6-0.1-24.4 1.3992-31.5 2.6992-10.5 2-14.5 3.8004-30.1 7.4004-0.8 0.2-13.901 3.2004-27.301 5.4004-12.3 2-29.6 4.1-51.1 4.5zm280 0h140.01v-20c-13.6-0.1-24.41 1.3992-31.51 2.6992-10.5 2-14.5 3.8004-30.1 7.4004-0.8 0.2-13.901 3.2004-27.301 5.4004-12.3 2-29.6 4.1-51.1 4.5z" />
                        </symbol>
                        <use className='fg' href='#thescorewave'></use>
                        <use className='bg' href='#thescorewave'></use>
                    </svg>
                </div>
                <div className='progress-liquid-body'></div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    overflow: hidden;
    border-radius: 10px;
    /* transform: rotate(90deg) translateY(-410px); */

    background-color: ${(props) => colorOpacity(props.theme.primaryColor, 0.2)};
    background-color: ${(props) => colorBlend(props.theme.primaryColor, props.theme.foregroundColor, 0.8)};


    .progress-liquid {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        transform: translateY(100%);
        transition: transform 0.3s;
    }

    .progress-liquid-wave {
        flex-shrink: 1;

        .progress-liquid-wave-svg {
            width: 200%;
            display: block;
            /* margin-bottom: -1px; */
            .fg {fill: ${(props) => props.theme.primaryColor}; animation: wave-fg 1.7s infinite linear;}
            .bg {fill: ${(props) => colorOpacity(props.theme.primaryColor, 0.6)}; animation: wave-bg 2.5s infinite linear;}
        }
    }

    .progress-liquid-body {
        width: 100%;
        background-color: ${(props) => props.theme.primaryColor};
        flex: 0 0 100%;
    }

    @keyframes wave-bg { 0% {transform: translate(-50%, 0)} 100% {transform: translate(0, 0);} }
    @keyframes wave-fg { 0%{transform: translate(0, 0);} 100% {transform: translate(-50%, 0);} }
`